export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE";
export const SET_MODE_CATEGORIE = "SET_MODE_CATEGORIE";
export const SET_MODE_BLACK_LIST = "SET_MODE_BLACK_LIST";
export const SET_QUESTIONS = "SET_QUESTIONS";
export const SET_ELEMENT_OF_RANK = "SET_ELEMENT_OF_RANK";
export const SET_QUIZZE = "SET_QUIZZE";
export const VIDER_STATE = "VIDER_STATE";
export const LOGOUT_S = "LOGOUT_S";
